import React, { Component } from "react";
import {
    MDBBtn,
    MDBModalBody,
    MDBModalHeader,
    MDBRow,
    MDBCol,
    MDBTooltip,
    MDBIcon,
    toast,
} from "mdbreact";
import { withTranslation } from "react-i18next";
import { Modal, Typography, CircularProgress, Box } from "@mui/material";
import axios from "../../../../axios";
import SelectSearch, { fuzzySearch } from "react-select-search";
class EditDomainAdministrator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedRole: props.administrator?.role || "",
            userDetails: null,
            updateModal: { open: false, email: '', role: '' },
            roleOptions: [
                { value: "DomainAdministrator", name: "Domain Administrator" },
                { value: "SIEMAdministrator", name: "SIEM Administrator" },
                { value: "AccountManager", name: "Account Manager" },
                { value: "CustomerSupport", name: "Customer Support" },
            ],
        };
    }
    componentDidMount() {
        // Set initial role if administrator prop is provided
        if (this.props.administrator) {
            this.setState({
                selectedRole: this.props.administrator.role
            });
            this.fetchUserDetails(this.props.administrator.email);
        }
    }
    componentDidUpdate(prevProps) {
        // Update role if administrator prop changes
        if (prevProps.administrator !== this.props.administrator && this.props.administrator) {
            this.setState({
                selectedRole: this.props.administrator.role
            });
            this.fetchUserDetails(this.props.administrator.email);
        }
    }
    fetchUserDetails = (emailAddress) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            EmailAddress: emailAddress,
        };
        axios
            .post("/networkoperatorconsole/subscribers/listSubscriberKeys", body, {
                headers: { "api-version": "20260417" },
            })
            .then((response) => {
                this.setState({
                    userDetails: {
                        GivenName: response.data.GivenName,
                        FamilyName: response.data.FamilyName,
                        locale: response.data.locale
                    }
                });
            })
            .catch((error) => {
                console.error("Error fetching user details:", error);
                // Set fallback values if API call fails
                this.setState({
                    userDetails: {
                        GivenName: this.props.administrator.firstName,
                        FamilyName: this.props.administrator.lastName || "",
                        locale: "en-us"
                    }
                });
            });
    };
    handleSelectChangeRole = (value) => {
        if (value !== null) {
            this.setState({ selectedRole: value });
        }
    };
    submitEditRole = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        if (this.state.selectedRole !== undefined && this.state.selectedRole !== "") {
            // Show the update modal
            const newRoleName = this.state.roleOptions.find(role => role.value === this.state.selectedRole)?.name || this.state.selectedRole;
            this.setState({ 
                loading: true,
                updateModal: { open: true, email: this.props.administrator.email, role: newRoleName }
            });
            // First, disable staff access
            let disableBody = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                EmailAddress: this.props.administrator.email
            };
            axios
                .post("/networkoperatorconsole/staff/disableStaffAccess", disableBody, {
                    headers: {},
                })
                .then((response) => {
                    // Then, enable staff access with new role
                    let enableBody = {
                        AccessToken: sessionStorage.getItem("AccessToken"),
                        EmailAddress: this.props.administrator.email,
                        Role: this.state.selectedRole,
                        GivenName: this.state.userDetails?.GivenName || this.props.administrator.firstName || this.props.administrator.email.split('@')[0],
                        FamilyName: this.state.userDetails?.FamilyName || this.props.administrator.lastName || "",
                        Language: this.state.userDetails?.locale || this.props.administrator.language || "en-us"
                    };
                    return axios.post("/networkoperatorconsole/staff/enableStaffAccess", enableBody, {
                        headers: {},
                    });
                })
                .then((response) => {
                    this.setState({ 
                        loading: false,
                        updateModal: { open: false, email: '', role: '' }
                    });
                    if (this.props.onRoleUpdated) {
                        this.props.onRoleUpdated(this.props.administrator.id, this.state.selectedRole);
                    }
                    // Refresh the administrators table to show the new role
                    if (this.props.refreshAdministratorsTable) {
                        this.props.refreshAdministratorsTable();
                    }
                    // Show success notification
                    const newRoleName = this.state.roleOptions.find(
                        role => role.value === this.state.selectedRole
                    )?.name || this.state.selectedRole;
                    toast.success(`Administrator role successfully updated to ${newRoleName}`, {
                        closeButton: false,
                        autoClose: 4000,
                    });
                    this.props.toggleEditDomainAdministrator();
                })
                .catch((error) => {
                    this.setState({ 
                        loading: false, 
                        error: true,
                        updateModal: { open: false, email: '', role: '' }
                    });
                    console.error("Error updating administrator role:", error);
                    // Show error notification
                    toast.error("Failed to update administrator role. Please try again.", {
                        closeButton: false,
                        autoClose: 5000,
                    });
                });
        }
    };
    render() {
        const { t, administrator } = this.props;
        if (!administrator) {
            return null;
        }
        const currentRoleName = this.state.roleOptions.find(
            role => role.value === administrator.role
        )?.name || administrator.role;
        return (
            <>
                {/* Update Role Modal */}
                <Modal
                    open={this.state.updateModal.open}
                    onClose={() => {}} // Prevent manual closing during update
                    aria-labelledby="update-modal-title"
                    aria-describedby="update-modal-description"
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 400,
                            bgcolor: 'background.paper',
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                            p: 4,
                            outline: 'none',
                            textAlign: 'center',
                        }}
                    >
                        <CircularProgress 
                            size={48} 
                            sx={{ 
                                color: '#0d6efd', 
                                mb: 2 
                            }} 
                        />
                        <Typography 
                            id="update-modal-title" 
                            variant="h6" 
                            component="h2"
                            sx={{ 
                                mb: 1,
                                fontWeight: 600,
                                color: '#333'
                            }}
                        >
                            Updating Administrator Role
                        </Typography>
                        <Typography 
                            id="update-modal-description" 
                            sx={{ 
                                color: '#666',
                                fontSize: '0.9rem'
                            }}
                        >
                            Updating {this.state.updateModal.email} to {this.state.updateModal.role}...
                        </Typography>
                    </Box>
                </Modal>
                <MDBModalHeader toggle={this.props.toggleEditDomainAdministrator}>
                    <h4>Edit Administrator Role</h4>
                    {/* <p>Modify the role for {this.state.userDetails?.GivenName || administrator.firstName} {this.state.userDetails?.FamilyName || administrator.lastName}</p> */}
                </MDBModalHeader>
                <MDBModalBody>
                    <div className="mb-3">
                        <p className="text-muted">
                            If you want a user to have multiple roles, please add the user once for each role.
                        </p>
                    </div>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitEditRole}
                        noValidate
                    >
                        <MDBRow>
                            <MDBCol sm="12" lg="6">
                                <label className="black-text">
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={administrator.email}
                                    disabled
                                    readOnly
                                />
                            </MDBCol>
                            <MDBCol sm="12" lg="6">
                                <label className="black-text">
                                    Administrator Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={`${this.state.userDetails?.GivenName || administrator.firstName || ''} ${this.state.userDetails?.FamilyName || administrator.lastName || ''}`}
                                    disabled
                                    readOnly
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12" lg="6">
                                <label className="black-text">
                                    Current Role
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={currentRoleName}
                                    disabled
                                    readOnly
                                />
                            </MDBCol>
                            <MDBCol sm="12" lg="6">
                                <div>
                                    <label className="black-text">
                                        New Role *
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            Domain Admin - Super Admins of VAULT system
                                            <br />
                                            SIEM Admin - Receives e-mail security, incident, and event management notifications
                                            <br />
                                            Account Manager - Venue Admin for all Venues within the environment
                                            <br />
                                            Customer Support - Access to subscriber modifications in network admin UI. May not edit venues
                                        </span>
                                    </MDBTooltip>
                                    <SelectSearch
                                        id="selectNewRole"
                                        search={true}
                                        filterOptions={fuzzySearch}
                                        options={this.state.roleOptions}
                                        isOptionSelected={true}
                                        classNamePrefix="role-select"
                                        onChange={this.handleSelectChangeRole}
                                        value={this.state.selectedRole}
                                        placeholder="Select new role..."
                                    />
                                    <div className="invalid-feedback">
                                        Please select a new role.
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <div className="text-right submitButton">
                            <MDBBtn 
                                color="primary" 
                                type="button"
                                onClick={this.props.toggleEditDomainAdministrator}
                                style={{ marginRight: "10px" }}
                            >
                                Cancel
                            </MDBBtn>
                            <MDBBtn color="primary" type="submit" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                ) : (
                                    "Update Role"
                                )}
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}
export default withTranslation()(EditDomainAdministrator);